import Value from "aldoo-ra/Value"
import { useEffect } from "react"
import { GetUserProfile } from "../api"
import { usePromise } from "aldoo-ra/usePromise"

export default function Profile() {
    //get the user-credentials value and watch for changes
    //if there is a valid credentials object, we will get the user profile
    const [auth] = Value("user-credentials")
    const [, setProfile] = Value({
        key: "user-profile",
        defaultValue: null,
        persistKey: "user-profile",
    })


    const { result, execute, pending, reset } = usePromise(async () => {
        //iek is inflight encryption key used to decode passwords and texts
        return await GetUserProfile({
            fields: "name avatar email devices iek",
        })
    }, true)

    useEffect(() => {
        //reset the profile if there are no credentials
        if (!auth) {
            reset()
            return setProfile(undefined)
        }
        // Only execute if we have auth with a valid token to prevent race conditions
        // during OAuth signin where auth object exists but token hasn't propagated yet
        if (auth && auth.auth_token && !pending && !result) execute()
        if (result && !result.error) setProfile(result)

    }, [auth, result])

}

/**
 * Refresh the user profile - can be called from anywhere to update profile data
 * @param {string} fields - Optional fields to fetch (defaults to standard fields + account_type)
 * @returns {Promise<object>} The updated profile object
 */
export async function refreshProfile(fields = "name avatar email devices iek account_type") {
    try {
        // Import setValue dynamically to avoid hook issues
        const { setValue } = await import("aldoo-ra/Value")
        const updatedProfile = await GetUserProfile({ fields })
        if (updatedProfile && !updatedProfile.error) {
            // Use the non-hook setValue function
            setValue('user-profile', updatedProfile, 'user-profile')
            return updatedProfile
        }
        return null
    } catch (error) {
        console.error("Failed to refresh user profile:", error)
        return null
    }
}